import { Component, OnInit, ChangeDetectorRef, Inject, ChangeDetectionStrategy, ElementRef, ViewChild } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from "@angular/material";
import { CoreLogService } from "../../services/log.service";
import { SnackBarMessageType, SortDirection } from "../../shared/contentTypes";
import { SnackBarService, snackBarMessageKey } from "../../services/snackBar.service";
import { SortOption } from "../../shared/models/sort.model";
import { PagingHelper } from "../../shared/pagingHelper";
import { LocationService } from "../../components/location/location.service";

@Component({
  selector: "filterlocationdialog",
  templateUrl: "./filterLocationDialog.component.html",
  styleUrls: ["./filterLocationDialog.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterLocationDialogComponent implements OnInit {
  @ViewChild("locationListView") locationListView: ElementRef;
  public likedLocations: any[];
  public locations: any[];
  private sortOption: SortOption[];
  private pagingHelper: PagingHelper;

  constructor(public bottomSheetRef: MatBottomSheetRef<FilterLocationDialogComponent>,
    private _locationService: LocationService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _coreLogService: CoreLogService,
    @Inject(MAT_BOTTOM_SHEET_DATA) public filterLocationIds: number[],
    private _snackBarService: SnackBarService) {
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._coreLogService.error("FilterLocationDialogComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  ngOnInit() {
    const me = this;
    me.pagingHelper = new PagingHelper();
    me.sortOption = [];
    me.sortOption.push(me.pagingHelper.createSortOption("like", SortDirection.DESC));
    me.sortOption.push(me.pagingHelper.createSortOption("selected", SortDirection.DESC));
    me.sortOption.push(me.pagingHelper.createSortOption("sort_nr", SortDirection.ASC));
    me.reloadAndRenderData();
    me.PushChanges();
  }

  private reloadAndRenderData() {
    const me = this;
    me._locationService.GetLocationViewModel()
      .then((locations) => {
        const unsetLocations = me.initializedFilter(locations);
        me.likedLocations = unsetLocations.filter(loc => loc.like);
        if (me.likedLocations) {
          me.likedLocations.sort(me.pagingHelper.fieldSorter(me.sortOption));
        }
        me.locations = unsetLocations.filter(loc => !loc.like);
        if (me.locations) {
          me.locations.sort(me.pagingHelper.fieldSorter(me.sortOption));
        }
        me.PushChanges();
        me.setLocationsStyle();
      })
      .catch(e => {
        me._coreLogService.error("FilterLocationDialogComponent.reloadAndRenderData", "GetLocationViewModel", e);
        me._snackBarService.ShowErrorMessageFailed(111);
      });
  }

  private initializedFilter(locations: any) {
    const me = this;
    locations.forEach((location, index) => {
      location.position = index;
      if (me.filterLocationIds.includes(location.hyp_cus_nr)) {
        location["selected"] = true;
      } else {
        location["selected"] = false;
      }
    });
    return locations;
  }

  public toggleFilterSelection(location: any): void {
    const me = this;
    location.selected = !location.selected;
    me.locations.sort(me.pagingHelper.fieldSorter(me.sortOption));
    me.PushChanges();
    setTimeout(() => {
      me.setLocationsStyle();
    }, 200);
  }

  // set style for location list for animation effect
  private setLocationsStyle() {
    const me = this;
    const vh: number = +document.documentElement.style.getPropertyValue("--vh").replace("px", "");
    const itemList: HTMLElement[] = Array.from(me.locationListView.nativeElement.getElementsByTagName("a"));
    let topOffset = 0;
    itemList.forEach(element => {
      element.style.position = "absolute";
      element.style.top = topOffset + "px";
      topOffset += element.clientHeight;
    });
    if (topOffset < (60 * vh)) {
      me.locationListView.nativeElement.style.height = topOffset + "px";
    } else {
      me.locationListView.nativeElement.style.height = (60 * vh) + "px";
    }
  }

  public saveFilter() {
    const me = this;
    const allLocations = [...me.likedLocations, ...me.locations];
    me.bottomSheetRef.dismiss(allLocations.filter(l => l["selected"]).map(s => s["hyp_cus_nr"]));
  }
}
